var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 9h30v2H0z","fill":"#404040","key":0}),React.createElement("line",{"x1":"0","y1":"15","x2":"30","y2":"15","stroke":"#404040","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M0 19h30v2H0z","fill":"#404040","key":2})]);
}

Menu.defaultProps = {"width":"30","viewBox":"0 0 30 30"};

module.exports = Menu;

Menu.default = Menu;
